import React from 'react';
import { AlertTriangle } from 'lucide-react';

// Shown when finishing the run would create a second open quote of the same type on this property.
export default function DuplicateAppraisalPrompt({ dupe, busy, onUseExisting, onCreateAnyway }) {
  const ex = dupe?.existing || {};
  return (
    <div data-testid="wf-duplicate-prompt"
      className="mt-4 max-w-lg mx-auto text-left text-sm bg-amber-50 border border-amber-300 rounded p-4">
      <div className="flex items-start gap-2 text-amber-900 font-semibold">
        <AlertTriangle size={16} className="mt-0.5 shrink-0" />
        <span data-testid="wf-duplicate-detail">{dupe?.detail}</span>
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        <button type="button" disabled={busy} onClick={onUseExisting} data-testid="wf-duplicate-use-existing"
          className="px-3 py-1.5 rounded bg-amber-600 text-white font-semibold hover:bg-amber-700 disabled:opacity-50 transition-colors">
          Use existing A{ex.appraisal_no}
        </button>
        <a href={`/appraisals/${ex._id}`} target="_blank" rel="noreferrer" data-testid="wf-duplicate-open-existing"
          className="px-3 py-1.5 rounded border border-amber-400 text-amber-800 bg-white hover:bg-amber-100 transition-colors">
          Open it in a new tab
        </a>
        <button type="button" disabled={busy} onClick={onCreateAnyway} data-testid="wf-duplicate-create-anyway"
          className="px-3 py-1.5 rounded border border-slate-300 text-slate-700 bg-white hover:bg-slate-50 disabled:opacity-50 transition-colors">
          Create a second quote anyway
        </button>
      </div>
    </div>
  );
}
